import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Grid,
  TextField,
  Typography,
  Card,
  CardContent,
  Avatar,
  Button,
  Snackbar,
  Alert,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import { getDoc, doc, serverTimestamp, setDoc ,increment } from "firebase/firestore";
import { db } from "../../../firebase";
import { useLocation } from "react-router-dom";
import {
  AccountBalanceWallet,
  MonetizationOn,
  LocalAtm,
  FormatListBulleted,
} from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const Fullview = () => {
  const [data, setData] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [remarks, setRemarks] = useState("");
  const location = useLocation();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("sm"));

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const paymentId = params.get("uid"); // Fetching paymentId from URL query param uid
    if (paymentId) {
      fetchData(paymentId);
    }
  }, [location.search]);

  const fetchData = async (paymentId) => {
    try {
      const docRef = doc(db, "withdraw_request", paymentId); // Assuming "transactions" is your Firestore collection name
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setData(docSnap.data());
        setRemarks(docSnap.data().remarks || "");
      } else {
        console.log("No such document!");
      }
    } catch (error) {
      console.error("Error fetching document:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      const paymentId = data.id; // Assuming data has paymentId field
      if (!paymentId) {
        setAlertSeverity("error");
        setAlertMessage("Payment ID is required to save data.");
        setShowAlert(true);
        return;
      }
      await setDoc(doc(db, "withdraw_request", paymentId), {
        ...data,
        remarks: remarks,
        timestamp: serverTimestamp(),
      });
      setAlertSeverity("success");
     
      setAlertMessage("Data saved successfully!");
    } catch (err) {
      console.error("Error saving data:", err);
      setAlertSeverity("error");
      setAlertMessage(`Error: ${err.message}`);
    } finally {
      setShowAlert(true);
    }
  };



  const handleAlertClose = () => {
    setShowAlert(false);
  };

  const formatTimestamp = (timestamp) => {
    const date = timestamp.toDate();
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    };
    return date.toLocaleDateString("en-US", options);
  };

  return (
    <div className="App">
      <main style={{ padding: "20px 5px" }}>
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={10} md={8} lg={6}>
            <Avatar
              alt={data.userName}
              src={data.userImage || "/placeholder.jpg"}
              style={{
                width: 100,
                height: 100,
                margin: "0 auto",
                marginBottom: 20,
              }}
            />
            <Card style={{ margin: "0 auto" }}>
              
              <CardContent>
              <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ gap: "20px", marginBottom: "16px" }}
                >
              <Grid item>
                    <Typography
                      variant="h6"
                      color="#272727"
                      align="center"
                      gutterBottom
                    >
                      Withdraw Request
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Link
                      to={`/users/fullview?uid=${data.user_id}`}
                      style={{ textDecoration: "none" }}
                    >
                      <div className="viewButton"> VIEW USER PROFILE </div>
                    </Link>
                  </Grid>
                  </Grid>
            

          
                <form onSubmit={handleSave}>
                  <Grid container spacing={4}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Payment ID"
                        name="id"
                        value={data.id || ""}
                        onChange={handleInputChange}
                        fullWidth
                        variant="outlined"
                      />
                      <TextField
                        label="Email"
                        name="email"
                        value={data.email || ""}
                        onChange={handleInputChange}
                        fullWidth
                        variant="outlined"
                        disabled
                        style={{ marginTop: "16px" }}
                      />
                      <TextField
                        label="User ID"
                        name="user_id"
                        value={data.user_id || ""}
                        onChange={handleInputChange}
                        fullWidth
                        variant="outlined"
                        disabled
                        style={{ marginTop: "16px" }}
                      />
                        <FormControl fullWidth variant="outlined" margin="dense">
                        <InputLabel>Status</InputLabel>
                        <Select
                          name="status"
                          value={data.status || ""}
                          onChange={handleInputChange}
                          label="Status"
                        >
                          <MenuItem value="Accepted">Accepted</MenuItem>
                          <MenuItem value="Completed">Completed</MenuItem>
                          <MenuItem value="Pending">Pending</MenuItem>
                          <MenuItem value="Refunded">Refunded</MenuItem>
                          <MenuItem value="Rejected">Rejected</MenuItem>
                        </Select>
                      </FormControl>
                     
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Contact"
                        name="contact"
                        value={data.contact || ""}
                        onChange={handleInputChange}
                        fullWidth
                        variant="outlined"
                      />
                      <TextField
                        label="Amount"
                        name="amount"
                        value={data.amount || ""}
                        onChange={handleInputChange}
                        fullWidth
                        variant="outlined"
                        disabled
                        style={{ marginTop: "16px" }}
                      />
                      <TextField
                        label="Timestamp"
                        name="timestamp"
                        value={
                          data.timestamp ? formatTimestamp(data.timestamp) : ""
                        }
                        onChange={handleInputChange}
                        fullWidth
                        variant="outlined"
                        disabled
                        style={{ marginTop: "16px" }}
                      />
                     
                      <TextField
                        label="Description"
                        name="description"
                        value={data.description || ""}
                        onChange={handleInputChange}
                        fullWidth
                        variant="outlined"
                        disabled
                        style={{ marginTop: "16px" }}
                      />
                    
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="h6" align="center">
                        Remarks
                      </Typography>
                      <TextField
                        id="remarks"
                        name="remarks"
                        label="Add remarks"
                        multiline
                        rows={4}
                        fullWidth
                        variant="outlined"
                        value={remarks}
                        onChange={(e) => setRemarks(e.target.value)}
                        style={{ marginTop: "8px" }}
                      />
                    </Grid>
                    <Grid container justifyContent="center">
                      <Grid item>
                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          sx={{
                            borderRadius: 15,
                            boxShadow: "none",
                            width: "200px",
                            marginTop: "16px",
                          }}
                        >
                          Save
                        </Button>
                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          sx={{
                            marginLeft:4,
                            borderRadius: 15,
                            boxShadow: "none",
                            width: "200px",
                            marginTop: "16px",
                          }}
                        >
                          Release Coin
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </form>
              </CardContent>
            </Card>
            <Snackbar
              open={showAlert}
              autoHideDuration={6000}
              onClose={handleAlertClose}
            >
              <Alert
                onClose={handleAlertClose}
                severity={alertSeverity}
                sx={{ width: "100%" }}
              >
                {alertMessage}
              </Alert>
            </Snackbar>
          </Grid>
        </Grid>
      </main>
    </div>
  );
};

export default Fullview;
